<template>
    <div class="left-side">
          <div class="game-banner">
            <span><b>Canlı</b> Monopoly</span>
            <a href="" class="button secondary">Şimdi Oyna</a>
          </div>
          <div class="pay">
            <router-link :to="{ name : 'User', params:{ section: 'deposit' } }" class="button primary">Para Yatır</router-link>
          </div>
          <Search/>
          <div class="last-games">
            <h5>Favori Oyunlar</h5>
            <slot name="fav"></slot>
          </div>
    </div>
</template>

<script>
  import FavGames from './FavGames'
  import Search from './Search'
  export default{
    data(){
      return{
        winner: 'last',
      }
    },  
    components:{
      Search,
      FavGames
    }
  }
</script>